// extracted by mini-css-extract-plugin
export var container = "index-module--container--2oXsF";
export var image = "index-module--image--1W4yR";
export var info = "index-module--info--1hHSZ";
export var title = "index-module--title--MMgEE";
export var description = "index-module--description--36bb9";